import React, { ButtonHTMLAttributes, FunctionComponent } from 'react';

import BaseButton from '../BaseButton';
import styleClassNames from './styles.module.scss';

interface TextButtonProps {
  icon?: string;
  iconSize?: number;
  isLoading?: boolean;
  loadingCopy?: string;
  size?: ButtonSize;
}

type ButtonSize = 'small' | 'medium' | 'large';

const TextButton: FunctionComponent<TextButtonProps & ButtonHTMLAttributes<HTMLButtonElement>> = (
  props
) => {
  const baseProps = {
    ...props,
    styleClassNames,
    variantName: 'text',
  };

  return <BaseButton {...baseProps} />;
};

export default TextButton;
